import { combineValidators, isRequired } from 'revalidate';

export const fieldsLabels = {
  email: 'Email',
  password: 'Password',
};

export default combineValidators({
  email: isRequired(fieldsLabels.email),
  password: isRequired(fieldsLabels.password),
});
